interface Props {
  label: string;
  value: string;
  detail?: string;
}

export function StatTile({ label, value, detail }: Props) {
  return (
    <div className="tile">
      <span className="tile__label">{label}</span>
      <span className="tile__value">{value}</span>
      {detail && <span className="tile__detail">{detail}</span>}
    </div>
  );
}
